<template>
  <div>
    <loading :active.sync="isLoading"
             :is-full-page="fullPage"/>

    <div class="ui segment" v-if="isUpdating && !isLoading">
      <p class="ui red zw compact header">{{ $t('pages.checkout.update.title') }}</p>
      <ul>
        <li>{{ $t('pages.checkout.update.hint_1') }}</li>
        <li>{{ $t('pages.checkout.update.hint_2') }}</li>
        <li>{{ $t('pages.checkout.update.hint_3') }}</li>
      </ul>
    </div>

    <div class="ui segment" v-if="!isUpdating && !isLoading">
      <p class="ui red zw compact header">{{ $t('pages.checkout.general.title') }}</p>
      <ul>
        <li>{{ $t('pages.checkout.general.hint_1') }}</li>
        <li>{{ $t('pages.checkout.general.hint_2') }}</li>
        <li>{{ $t('pages.checkout.general.hint_3') }}</li>
        <template v-if="unscheduled">
          <li>{{ $t('pages.checkout.kamstrup.hint_1') }}</li>
          <li>{{ $t('pages.checkout.kamstrup.hint_3') }}</li>
        </template>
      </ul>
    </div>

    <div id="dibs-complete-checkout"></div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import moment from 'moment/moment'

export default {
	name: 'Checkout',

	data () {
		return {
      possibleContainers: ['subscription', 'booked', 'waitlist'],
      container: null,
      containerId: null,
      paymentId: null,
      checkoutKey: null,
      endpoint: '',
      isUpdating: false,
      selfRedirect: false,
      isLoading: false,
      fullPage: true,
      dibsReady: false,
      checkingInterval: null,
      withOverdueFee: false,
      unscheduled: false,
      interval: null,
      counter: 0,
      counterLimit: process.env.NODE_ENV === 'local' ? 5 : 10
		}
	},

  components: {
    Loading
  },

  created: function () {
    let checkoutUrl = process.env.CHECKOUT_URL

    let script = document.createElement('script')
    script.setAttribute('src', checkoutUrl)
    document.head.appendChild(script)
  },

  mounted () {
    const body = document.querySelector('body')
    body.classList.remove('not-scrollable')
    this.isLoading = true
    this.setEndpoint()

    if (!this.$route.query.container || !this.possibleContainers.includes(this.$route.query.container)) {
      this.selfRedirect = true
      this.$router.push('/dashboard')
    } else {
      let data = {}
      if (this.$route.query.subscriptionId) {
        this.isUpdating = true
        data = {'nets_subscription_id': this.$route.query.subscriptionId}
      }

      if (this.$route.query.overdue_fee) {
        this.withOverdueFee = true
      }

      if (this.$route.query.unscheduled) {
        this.unscheduled = true
        data = {
          'unscheduled': this.$route.query.unscheduled,
        }

        if (this.$route.query.unscheduledSubscriptionId) {
          this.isUpdating = true
          data['unscheduled_subscription_id'] = this.$route.query.unscheduledSubscriptionId
        }
      }
      if (this.$route.query.setupPaymentMethod) {
        data['setup_payment_method'] = true
      }
      this.createPayment(data).then(() => {
        this.checkDibsIsReady()
      })
    }
  },

  watch: {
    dibsReady (val) {
      if (val) {
        clearInterval(this.checkingInterval)
        this.initCheckout()
      }
    }
  },

  methods: {
    checkDibsIsReady () {
      let $this = this

      this.checkingInterval = setInterval(function() {
        console.log('checking Dibs is defined')
        if (Dibs) {
          console.log('Dibs is defined')
          $this.isLoading = false
          $this.dibsReady = true
        } else {
          console.log('Dibs is not defined yet')
        }
      }, 1500)
    },

    setEndpoint () {
      if (this.$route.query.container === 'waitlist') {
        this.endpoint = 'waitlistsubscriptions/'
      } else if (this.$route.query.container === 'subscription') {
        this.endpoint = 'subscriptions/'
      } else if (this.$route.query.container === 'booked') {
        this.endpoint = 'booked/'
      }
    },

    createPayment (data) {
      return new Promise((resolve, reject) => {
        this.axios.post(this.endpoint + this.$route.params.containerId + '/createPayment', data)
          .then((response) => {
            if (response.status === 204) {
              this.selfRedirect = true
              if (this.$route.query.container === 'booked') {
                this.$router.push({name: 'bookings'})
              }
            } else {
              this.paymentId = response.data.paymentId
              this.checkoutKey = response.data.checkoutKey

              if (!this.isUpdating) {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.success.success'),
                  message: this.$t('modals.newsubscriptionmodal.validation.nets.success.payment_created'),
                  type: 'success',
                  align: 'right'
                })
              }

              resolve(response)
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.message === 'missing_parameters') {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.errors.payment_title'),
                  message: this.$t('globals.validation.errors.missing_parameters'),
                  type: 'error',
                  align: 'right'
                })
                this.selfRedirect = true
                setTimeout(() => this.$router.push({name: 'profile'}), 3000)
              } else {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.errors.error'),
                  message: error.response.data.message,
                  type: 'error',
                  align: 'right'
                })
                this.selfRedirect = true

                if (this.$route.query.container === 'booked') {
                  setTimeout(() => this.$router.push({name: 'bookings'}), 3000)
                } else {
                  setTimeout(() => this.$router.push('/dashboard'), 3000)
                }
              }
            } else {
              this.$events.$emit('alert', {
                header: this.$t('globals.validation.errors.something_went_wrong'),
                message: this.$t('globals.validation.errors.try_again_later'),
                type: 'error',
                align: 'right'
              })
              this.selfRedirect = true
              this.$router.push('/dashboard')
            }
            reject(error)
          })
      })
    },

    initCheckout () {
      const checkoutOptions = {
        checkoutKey: this.checkoutKey,
        paymentId: this.paymentId,
        containerId: 'dibs-complete-checkout',
        language: 'da-DK'
      }

      try {
        /*eslint-disable */
        const checkout = new Dibs.Checkout(checkoutOptions)
        /* eslint-enable */

        checkout.on('payment-completed', ({paymentId}) => {
          this.isLoading = true

          if (this.isUpdating) {
            const self = this

            this.interval = setInterval(function () {
              self.counter++
              self.checkPaymentId(paymentId)

              if (self.counter > self.counterLimit) {
                self.counter = 0
                clearInterval(self.interval)

                self.savePaymentDetails(paymentId).then(({data}) => {
                  self.$events.$emit('alert', {
                    header: self.$t('globals.validation.success.success'),
                    message: self.$t('modals.newsubscriptionmodal.validation.nets.success.subscription_updated'),
                    type: 'success',
                    align: 'right'
                  })

                  self.redirectToSuccessPage(data.id)
                })
              }
            }, 3000)
          } else {
            const self = this

            this.interval = setInterval(function () {
              self.counter++
              self.checkContainerStatus()

              if (self.counter > self.counterLimit) {
                self.counter = 0
                clearInterval(self.interval)

                self.processPaymentCompletedWithoutWebhook(paymentId)
              }
            }, 3000)
          }
        })
      } catch (e) {
        console.log(e)

        this.$events.$emit('alert', {
          header: this.$t('globals.validation.errors.something_went_wrong'),
          message: this.$t('globals.validation.errors.try_again_later'),
          type: 'error',
          align: 'right'
        })

        setTimeout(() => {
          this.terminatePayment('dashboard', true)
        }, 3000)
      }
    },

    checkContainerStatus () {
      this.axios.get(this.endpoint + this.$route.params.containerId + '/status')
        .then((response) => {
          if (response.data.status === 'active' || response.data.status === 'delayed' || response.data.status === 'overdue' || response.data.status === 'soft_overdue') {
            clearInterval(this.interval)

            this.redirectToSuccessPage(this.$route.params.containerId, 3000)
          }
        }).catch((error) => {
          console.log(error)
      })
    },

    checkPaymentId (paymentId) {
      this.axios.get(this.endpoint + this.$route.params.containerId + '/nets/payment_id')
        .then(({data}) => {
          if (data.payment_id === paymentId) {
            clearInterval(this.interval)

            this.$events.$emit('alert', {
              header: this.$t('globals.validation.success.success'),
              message: this.$t('modals.newsubscriptionmodal.validation.nets.success.subscription_updated'),
              type: 'success',
              align: 'right'
            })

            this.redirectToSuccessPage(this.$route.params.containerId, 3000)
          }
        }).catch((error) => {
        console.log(error)
      })
    },

    savePaymentDetails (paymentId) {
      return new Promise((resolve, reject) => {
        let data = {
          paymentId: paymentId,
          isUpdating: this.isUpdating
        }

        this.axios.put(this.endpoint + this.$route.params.containerId + '/savePaymentDetails', data)
          .then((response) => {
            resolve(response)
          }).catch((error) => {
          reject(error)
        })
      })
    },

    activateSubscriptionOrWaitlist (containerId) {
      return new Promise((resolve, reject) => {
        this.axios.put(this.endpoint + containerId + '/activate')
          .then((response) => {
            resolve(response)
          }).catch((error) => {
          reject(error)
        })
      })
    },

    activateBooked (bookedId) {
      return new Promise((resolve, reject) => {
        this.axios.put(`/booked/${bookedId}/activate`)
          .then((response) => {
            resolve(response)
          }).catch((error) => {
          reject(error)
        })
      })
    },

    processPaymentCompletedWithoutWebhook (paymentId) {
      this.savePaymentDetails(paymentId).then((response) => {
        let infoMessage = ''
        if (response.status === 204) {
          if (this.$route.query.container === 'subscription') {
            infoMessage = this.$t('modals.newsubscriptionmodal.validation.nets.success.subscription_added')
          } else {
            infoMessage = this.$t('modals.newwaitlistmodal.validation.success.waitlist_added')
          }

          this.$events.$emit('alert', {
            header: this.$t('globals.validation.success.success'),
            message: infoMessage,
            type: 'success',
            align: 'right'
          })
          setTimeout(() => {
            this.redirect()
          }, 3000)
        } else {
          if (this.$route.query.container === 'subscription') {
            infoMessage = this.$t('modals.newsubscriptionmodal.validation.nets.success.subscription_details_saved')
          } else if (this.$route.query.container === 'waitlist') {
            infoMessage = this.$t('modals.newwaitlistmodal.validation.success.waitlist_details_saved')
          } else {
            infoMessage = this.$t('modals.newbookingmodal.validation.nets.success.details_saved')
          }

          this.$events.$emit('alert', {
            header: this.$t('globals.validation.success.success'),
            message: infoMessage,
            type: 'success',
            align: 'right'
          })

          if (this.$route.query.container === 'booked') {
            this.activateBooked(this.$route.params.containerId).then((response) => {
              this.isLoading = false

              this.$events.$emit('booking-reserved', response.data.data)
              if (response.data.data.is_free) {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.success.success'),
                  message: this.$t('pages.bookings.validation.success.booking_added_free'),
                  type: 'success',
                  align: 'right'
                })
              } else {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.success.success'),
                  message: this.$t('pages.bookings.validation.success.booking_added_paid', {payment_time: moment(response.data.data.payment_time).format('YYYY-MM-DD HH:mm:ss')}),
                  type: 'success',
                  align: 'right'
                })
              }

              this.redirectToSuccessPage(response.data.data.id)
            }).catch((error) => {
              if (error.response.data.message) {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.errors.error'),
                  message: error.response.data.message,
                  type: 'error',
                  align: 'right'
                })
              }

              this.selfRedirect = true
              setTimeout(() => {
                this.$router.push({name: 'bookings'})
              }, 3000)
            })
          } else {
            this.activateSubscriptionOrWaitlist(this.$route.params.containerId).then((response) => {
              this.isLoading = false

              let infoMessage = ''

              if (response.status === 201) {
                if (this.$route.query.container === 'subscription') {
                  infoMessage = this.$t('modals.newsubscriptionmodal.validation.nets.success.subscription_added_with_failed_charge')
                } else {
                  infoMessage = this.$t('modals.newwaitlistmodal.validation.success.waitlist_added_with_failed_charge')
                }

                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.warning.warning'),
                  message: infoMessage,
                  type: 'warning',
                  align: 'right'
                })

                this.redirectToFailedPage(this.$route.params.containerId)
              } else {
                if (!this.withOverdueFee) {
                  if (this.$route.query.container === 'subscription') {
                    infoMessage = this.$t('modals.newsubscriptionmodal.validation.nets.success.subscription_added')
                  } else {
                    infoMessage = this.$t('modals.newwaitlistmodal.validation.success.waitlist_added')
                  }

                  this.$events.$emit('alert', {
                    header: this.$t('globals.validation.success.success'),
                    message: infoMessage,
                    type: 'success',
                    align: 'right'
                  })
                }

                this.redirectToSuccessPage(response.data.id)
              }
            }).catch((error) => {
              if (error.response.data.message) {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.errors.error'),
                  message: error.response.data.message,
                  type: 'error',
                  align: 'right'
                })
              }

              this.selfRedirect = true
              setTimeout(() => {
                this.redirect()
              }, 3000)
            })
          }
        }
      }).catch((error) => {
        if (error.response.data.message) {
          this.$events.$emit('alert', {
            header: this.$t('globals.validation.errors.error'),
            message: error.response.data.message,
            type: 'error',
            align: 'right'
          })
        } else {
          this.$events.$emit('alert', {
            header: this.$t('globals.validation.errors.something_went_wrong'),
            message: this.$t('globals.validation.errors.try_again_later'),
            type: 'error',
            align: 'right'
          })
        }

        this.selfRedirect = true
        this.$router.push('/dashboard')
      })
    },

    terminatePayment (routeName, logException = false) {
      let data = {
        paymentId: this.paymentId
      }

      if (logException) {
        data['logException'] = true
      }

      this.axios.put(this.endpoint + this.$route.params.containerId + '/terminatePayment', data)
        .then((response) => {
          if (response.status === 204) {
            this.selfRedirect = true
            this.$router.push({name: routeName}, () => {
              window.location.reload(true)
            })
          }
        }).catch((error) => {
        if (error.response) {
          if (error.response.data.message) {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.error'),
              message: error.response.data.message,
              type: 'error',
              align: 'right'
            })
          }
        }
        setTimeout(() => this.logOut(), 3000)
      })
    },
    logOut () {
      this.$auth.logout({
        makeRequest: true,
        redirect: {name: 'login'}
      })

      // Reset merchants from store -- In addition to vuex-persisted-state
      this.$store.dispatch('resetMerchants')
      this.$store.dispatch('resetMerchant')
    },

    redirectToSuccessPage(containerId, timeout = 1500) {
      let query = {
        container: this.$route.query.container,
        containerId: containerId,
      }

      if (this.isUpdating) {
        query['update'] = true
      }

      if (this.$route.query.intro) {
        query['intro'] = true
      }

      if (this.withOverdueFee) {
        query['overdue_fee'] = true
      }

      this.selfRedirect = true
      setTimeout(() => {
        this.$router.push({
          name: 'success',
          query: query
        })
      }, timeout)
    },

    redirectToFailedPage(containerId) {
      let query = {
        container: this.$route.query.container,
        containerId: containerId,
      }

      if (this.isUpdating) {
        query['update'] = true
      }

      if (this.$route.query.intro) {
        query['intro'] = true
      }

      if (this.withOverdueFee) {
        query['overdue_fee'] = true
      }

      this.selfRedirect = true
      setTimeout(() => {
        this.$router.push({
          name: 'failed',
          query: query
        })
      }, 1500)
    },

    redirect () {
      this.isLoading = false
      this.selfRedirect = true

      if (this.$route.query.container === 'subscription') {
        this.$router.push({name: 'subscriptiondashboard', params: {subscriptionId: this.$route.params.containerId}},
          () => {
            this.$router.go()
          }
        )
      } else {
        this.$router.push({name: 'wait_list'},
          () => {
            this.$router.go()
          }
        )
      }
    }
  },

  beforeRouteLeave (to, from, next) {
    if (!this.selfRedirect) {
      const answer = window.confirm(this.$t('globals.confirm.confirm_leave').toString())
      if (answer) {
        this.terminatePayment(to.name)
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/payment/Checkout.vue